
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/invideo-vs-descript-script-driven-video-editing",
      function () {
        return require("private-next-pages/blog/invideo-vs-descript-script-driven-video-editing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/invideo-vs-descript-script-driven-video-editing"])
      });
    }
  